import type { Role } from '@/features/auth/api';

/**
 * 「やりたいこと」からマニュアルを引く入口。
 * 画面名が分からない人でも、自分の言葉で探せるようにする。
 */
export interface QuickLink {
  /** 利用者の言葉で書いた目的 */
  question: string;
  /** 操作するページ（アプリ本体） */
  to: string;
  /** 詳しい手順（マニュアル） */
  helpTopicId: string;
  roles: Role[];
}

export const HELP_QUICK_LINKS: QuickLink[] = [
  {
    question: 'イベントの出欠を答えたい（出欠を取る回のみ）',
    to: '/events',
    helpTopicId: 'events',
    roles: ['student'],
  },
  {
    question: '課題やアンケートを出したい',
    to: '/events',
    helpTopicId: 'surveys',
    roles: ['student'],
  },
  {
    question: '欠席を伝えたい',
    to: '/events',
    helpTopicId: 'events',
    roles: ['student'],
  },
  {
    question: '事務局に質問したい',
    to: '/messages',
    helpTopicId: 'messages',
    roles: ['student', 'director', 'success'],
  },
  {
    question: '顔写真や自己紹介を登録したい',
    to: '/profile',
    helpTopicId: 'profile',
    roles: ['student'],
  },
  {
    question: '1年の記録（ポートフォリオ）を見たい',
    to: '/portfolio',
    helpTopicId: 'portfolio',
    roles: ['student'],
  },
  {
    question: '顔写真・会社名・連絡先を登録したい',
    to: '/account',
    helpTopicId: 'profile',
    roles: ['director', 'success', 'office', 'super_admin'],
  },
  {
    question: 'パスワードを変えたい・忘れた',
    to: '/account',
    helpTopicId: 'profile',
    roles: ['student', 'director', 'success', 'office', 'super_admin'],
  },
  {
    question: '関わった受講生のプロフィールを見たい',
    to: '/members',
    helpTopicId: 'members',
    roles: ['director', 'success'],
  },
  {
    question: '受講生の提出物・出欠をまとめて見たい',
    to: '/members',
    helpTopicId: 'portfolio',
    roles: ['director', 'success'],
  },
  {
    question: '面談の空き日時を登録したい',
    to: '/availability',
    helpTopicId: 'availability',
    roles: ['success'],
  },
  {
    question: '面談の記録を残したい',
    to: '/events',
    helpTopicId: 'success',
    roles: ['success'],
  },
  {
    question: '受講生を1人招待したい',
    to: '/members',
    helpTopicId: 'members',
    roles: ['office'],
  },
  {
    question: '受講生を表（CSV）でまとめて登録したい',
    to: '/members/import',
    helpTopicId: 'members',
    roles: ['office'],
  },
  {
    question: '月例会などのイベントを作って公開したい',
    to: '/events',
    helpTopicId: 'events',
    roles: ['office'],
  },
  {
    question: 'サクセス面談を組みたい',
    to: '/events',
    helpTopicId: 'events',
    roles: ['office'],
  },
  {
    question: '1on1を組みたい',
    to: '/events',
    helpTopicId: 'events',
    roles: ['office'],
  },
  {
    question: '期やコースを登録したい',
    to: '/masters/cohorts',
    helpTopicId: 'masters',
    roles: ['office'],
  },
  {
    question: 'イベントの種類（月例会・面談など）を足したい',
    to: '/masters/event-types',
    helpTopicId: 'masters',
    roles: ['office'],
  },
  {
    question: 'アンケート・課題のひな型を作りたい',
    to: '/masters/survey-templates',
    helpTopicId: 'masters',
    roles: ['office'],
  },
  {
    question: '自動で送るメールの文面を直したい',
    to: '/masters/notification-templates',
    helpTopicId: 'notification-setup',
    roles: ['office'],
  },
  {
    question: '自動で送るメールのタイミング・宛先を変えたい',
    to: '/masters/notification-presets',
    helpTopicId: 'notification-setup',
    roles: ['office'],
  },
  {
    question: '当日の席次表のもとになる出席者一覧がほしい',
    to: '/events',
    helpTopicId: 'events',
    roles: ['office'],
  },
  {
    question: 'この回の案内メールの時刻を変えたい・1通足したい',
    to: '/events',
    helpTopicId: 'events',
    roles: ['office'],
  },
  {
    question: '理事・講師を追加したい',
    to: '/directors',
    helpTopicId: 'staff',
    roles: ['office'],
  },
  {
    question: 'サクセス担当を追加したい',
    to: '/success-staff',
    helpTopicId: 'staff',
    roles: ['office'],
  },
  {
    question: '受講生や担当者がパスワードを忘れた',
    to: '/members',
    helpTopicId: 'members',
    roles: ['office'],
  },
  {
    question: '問い合わせに返信したい',
    to: '/inbox',
    helpTopicId: 'inbox',
    roles: ['office'],
  },
  {
    question: '採点結果を取り込んで公開したい',
    to: '/scores/manage',
    helpTopicId: 'scores',
    roles: ['office'],
  },
  {
    question: '社長アンケートを取り込みたい',
    to: '/surveys/president/import',
    helpTopicId: 'president',
    roles: ['office'],
  },
];

export function quickLinksFor(role: Role): QuickLink[] {
  return HELP_QUICK_LINKS.filter((link) => link.roles.includes(role));
}
